import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faLink,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ExportPresentation({ presentationId, slides, getLinks }) {
  const [showLinks, setShowLinks] = useState(false);

  const handleExportClick = () => {
    setShowLinks((prev) => !prev);

    // ✅ Save slides in localStorage by presentationId
    if (slides && slides.length > 0) {
      localStorage.setItem(`slides_${presentationId}`, JSON.stringify(slides));
    } else {
      toast.error("No slides to export!");
    }
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(
      () => toast.success("Link copied to clipboard!"),
      (err) => toast.error("Could not copy text.")
    );
  };

  const { speaker, attendee } = getLinks();

  return (
    <div className="flex flex-col items-end mb-12">
      <button
        onClick={handleExportClick}
        className={`px-3 py-2 rounded-md text-base font-bold bg-purple-400 hover:bg-purple-500 text-white ${
          showLinks ? "mt-4" : ""
        }`}
      >
        <FontAwesomeIcon icon={faFileExport} className="mr-2" />
        {showLinks ? "Hide Links" : "Export Presentation"}
      </button>

      {showLinks && presentationId && (
        <div className="mt-4 p-4 border border-gray-300 rounded-lg shadow-lg w-full max-w-md bg-white">
          <h3 className="text-lg font-semibold mb-2">Presentation Links</h3>

          {/* Speaker Link */}
          <div className="flex items-center justify-between p-4 mb-2 bg-gray-100 rounded">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faUser} className="mr-3 text-purple-400" />
              <div className="flex flex-col">
                <span className="font-medium mb-1">Speaker Link</span>
                <a
                  href={speaker}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline break-all"
                >
                  {speaker}
                </a>
              </div>
            </div>
            <button
              onClick={() => copyToClipboard(speaker)}
              className="ml-4 text-purple-400 hover:text-purple-800 text-sm"
              title="Copy link"
            >
              <FontAwesomeIcon icon={faLink} />
            </button>
          </div>

          {/* Attendee Link */}
          <div className="flex items-center justify-between p-4 bg-gray-100 rounded">
            <div className="flex items-center">
              <FontAwesomeIcon
                icon={faUsers}
                className="mr-3 text-purple-400"
              />
              <div className="flex flex-col">
                <span className="font-medium mb-1">Attendee Link</span>
                <a
                  href={attendee}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline break-all"
                >
                  {attendee}
                </a>
              </div>
            </div>
            <button
              onClick={() => copyToClipboard(attendee)}
              className="ml-4 text-purple-400 hover:text-purple-800 text-sm"
              title="Copy link"
            >
              <FontAwesomeIcon icon={faLink} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default ExportPresentation;

// const handleExportClick = () => {
//   setShowLinks((prev) => !prev);

//   // ✅ Save slides in localStorage by presentationId
//   if (slides && slides.length > 0) {
//     localStorage.setItem(`slides_${presentationId}`, JSON.stringify(slides));
//     toast.success("Slides exported successfully!");
//   } else {
//     toast.error("No slides to export!");
//   }
// };
